import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { DATA, PER_PAGE } from '@/plugins/vuex-async-pagginate';

class PhoneServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getAll(list_id, params = {}) {
    return this.getList(list_id, { [PER_PAGE]: 500, ...params }).then(res => res[DATA]);
  }

  getList(list_id, params = {}) {
    return this.http.get(`/${list_id}/phones`, { params: params });
  }

  createItem(list_id, params = {}) {
    return this.http.post(`/${list_id}/phones`, params);
  }

  removeItem(list_id, id) {
    return this.http.delete(`/${list_id}/phones/${id}`);
  }
}

export const PhoneService = new PhoneServiceClass({
  api_version: 2,
  resource: 'pbx/phone-lists'
});
